// extracted by mini-css-extract-plugin
export default {"container":"Lobby_container__fiEJD","usersContainer":"Lobby_usersContainer__0xKUf","usersContainer__list":"Lobby_usersContainer__list__VhEvj","floating":"Lobby_floating__jmi4e"};